import domReady from '@wordpress/dom-ready';
import { __ } from '@wordpress/i18n';
import { createElement, render } from '@wordpress/element';
import { Button } from '@wordpress/components';
import { pglyInitCodeEditors, openCustomScriptsModal } from './component/popup';

domReady(() => {
    function NewCustomScriptsButton() {
        return createElement(
            'div',
            { className: 'smcr-button-wrapper', style: { display: 'inline-block', marginLeft: '8px' } },
            createElement(Button, {
                icon: 'admin-customizer',
                isPrimary: true,
                onClick: openCustomScriptsModal,
                className: 'smcr-button',
                style: { height: '32px', position: 'relative' },
            }, esc_html__('Custom CSS & JS', 'current-template-name'))
        );
    }

    function insertButton() {
        const toolbar = document.querySelector('.edit-post-header-toolbar');
        if (!toolbar || document.querySelector('.smcr-button-container')) return;

        const container = document.createElement('div');
        container.className = 'smcr-button-container';
        toolbar.insertBefore(container, toolbar.children[1]);
        render(createElement(NewCustomScriptsButton), container);
    }

    // Initial insertion.
    insertButton();

    // Re-insert button if Gutenberg re-renders toolbar.
    let debounceTimeout;
    const observer = new MutationObserver(() => {
        clearTimeout(debounceTimeout);
        debounceTimeout = setTimeout(() => {
            if (!document.querySelector('.smcr-button-container')) insertButton();
        }, 100);
    });

    const observerTarget = document.querySelector('.interface-interface-skeleton__header') || document.body;
    observer.observe(observerTarget, { subtree: true, childList: true });

    window.addEventListener('unload', () => {
        observer.disconnect();
        clearTimeout(debounceTimeout);
    });

});
